import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  /**
   * Get a cookie by name
   * @param name The name of the cookie
   * @returns The parsed cookie value or null if not found
   */
  getCookie(name: string): any {
    const cookieArr = document.cookie.split(';');
    for (let i = 0; i < cookieArr.length; i++) {
      const cookie = cookieArr[i].trim();
      if (cookie.startsWith(name + '=')) {
        const cookieValue = cookie.substring(name.length + 1);
        return JSON.parse(decodeURIComponent(cookieValue));
      }
    }
    return null;
  }

  /**
   * Set a cookie with the given name, data, and expiration days
   * @param name The name of the cookie
   * @param data The data to store in the cookie
   * @param days The number of days until the cookie expires
   */
  setCookie(name: string, data: any, days: number): void {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    const cookieData = JSON.stringify(data);
    const env = environment.base_url.split('https://')[1];
    const domainStr = env && env?.split('.')[0].length ? `${env?.split('.')[1]}.com` : 'localhost';
    document.cookie = `${name}=${encodeURIComponent(cookieData)}; domain=${domainStr};SameSite=Lax; expires=${expires.toUTCString()}; path=/;`;
  }

  /**
   * Set a non-JSON cookie with the given name, value, and expiration days
   * @param name The name of the cookie
   * @param value The string value to store in the cookie
   * @param days The number of days until the cookie expires
   */
  setSimpleCookie(name: string, value: string, days: number): void {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    const env = environment.base_url.split('https://')[1];
    const domainStr = env && env?.split('.')[0].length ? `${env?.split('.')[1]}.com` : 'localhost';
    document.cookie = `${name}=${value}; domain=${domainStr};SameSite=Lax; expires=${expires.toUTCString()}; path=/;`;
  }

  /**
   * Delete a cookie by name
   * @param name The name of the cookie to delete
   */
  deleteCookie(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
  }
}
